import dataURIToBlob from '@/helpers/dataUriToBlob'

/**
 * Helper function to properly handler downloading Blobs
 *
 * @param {String} blob Base64 encoded file
 * @param {String} userFriendlyName The file name to be used when downloading the blob
 */
export default function({ fileString, userFriendlyName, isLink = false }) {
  const dataUriPrefix = 'data:application/octet-stream;base64,'
  let dataUri = fileString
  if (dataUri.indexOf('data:') === -1 && !isLink) {
    dataUri = `${dataUriPrefix}${fileString}`
  }

  if (isLink) {
    let link = document.createElement('a')
    link.href = fileString
    link.download = userFriendlyName

    document.body.appendChild(link)
    link.click()
    link.remove()
  } else {
    if (window.navigator.msSaveOrOpenBlob) {
      // older versions of IE11 do not have proper support for download Blobs
      // ref1: https://stackoverflow.com/a/24354303/1021300
      // ref2: https://msdn.microsoft.com/en-us/library/hh772332(v=vs.85).aspx
      window.navigator.msSaveOrOpenBlob(dataUri, userFriendlyName)
    } else {
      const blob = dataURIToBlob(dataUri)

      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = userFriendlyName

      document.body.appendChild(link)
      link.click()
      link.remove()
    }
  }
}
